export const FILTER_LOGS = "FILTER_LOGS"
export const CLEAR_LOGS_AND_CACHE = "CLEAR_LOGS_AND_CACHE"
export const INITIALIZE_LOGS_AND_CACHE = "INITIALIZE_LOGS_AND_CACHE"
